import React from 'react'

// reusable chart components
import ActionBreakdownChart from '../reusable-charts/ActionBreakdownChart'
import NavigationChart from '../reusable-charts/NavigationChart'


const HomeCharts = ({ clicks }) => {
  return (
    <div>

      <h6>Breakdown of all Home page tracking actions:</h6>
      <ActionBreakdownChart clicks={clicks} />
      <br />
      <hr />

      <h6>Navigation clicks to Home page by date and count:</h6>
      <NavigationChart clicks={clicks} />
      <br />
      <hr />
      
    </div>
  )
}

export default HomeCharts